export enum ParticipantRoles {
  Teacher = "Lærer",
  Student = "Student",
  Resource = "Ressurs",
}
